(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[111],{

/***/ 35280:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/updates/[slug]",
      function () {
        return __webpack_require__(16634);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 65345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 88054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(65345),
    de: __webpack_require__(76419)
};


/***/ }),

/***/ 82067:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 69368:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common,
    "section-try-for-free": __webpack_require__(33686)
};


/***/ }),

/***/ 27667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(69368),
    de: __webpack_require__(82067)
};


/***/ }),

/***/ 16634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 11 modules
var i18 = __webpack_require__(8610);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithConditions/index.js
var WithConditions = __webpack_require__(83803);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/create-and-raise.js
var create_and_raise = __webpack_require__(55161);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/createClient/index.js
var createClient = __webpack_require__(15959);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r2/BackToTopButton/index.js
var BackToTopButton = __webpack_require__(5370);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PostElement/index.js + 4 modules
var PostElement = __webpack_require__(22857);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/index.js + 1 modules
var GuidePageTemplate = __webpack_require__(41635);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/Sidebar.js
var Sidebar = __webpack_require__(51921);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/Main.js
var Main = __webpack_require__(43360);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/Nav.js
var Nav = __webpack_require__(69738);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r2/GuidePostPartials/index.js






// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/Guides/index.js
var Guides = __webpack_require__(61603);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/index.js + 1 modules
var Breadcrumbs = __webpack_require__(78086);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/Item.js
var Item = __webpack_require__(71125);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/richTextTypes/default/utils.js + 1 modules
var utils = __webpack_require__(69482);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/richTextTypes/default/index.js + 5 modules
var richTextTypes_default = __webpack_require__(34124);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/constants/index.js
var constants = __webpack_require__(34491);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/ReleaseNotes/Page.js


















const ReleaseNotesPage = (param)=>{
    let { post , pageProps  } = param;
    const [t] = (0,i18/* useLocale */.bU)("updates");
    const { siteDomain  } = pageProps;
    const { title , metaDescription ="" , slug , releaseDate , appVersionNumber , publishStatus , body  } = post;
    const currentPageURL = "".concat(siteDomain, "/updates/").concat(slug);
    const navigation = body ? (0,utils/* sidebarNavigation */.U)(body) : [];
    const metaRobotsContent = publishStatus === "Live" ? "index, follow" : "noindex, follow";
    const wasReleasedMessage = /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostElement/* PostElementParagraph */.DK, {
        italic: true,
        suppressHydrationWarning: true,
        children: [
            t("PRODUCT_NAME"),
            " ",
            appVersionNumber,
            " ",
            t("UPDATES.WAS_RELEASED_ON"),
            " ",
            t("{{releaseDate, LONGDATE}}", {
                releaseDate
            }),
            "."
        ]
    });
    const totalHeading2 = body.content.reduce((total, current)=>{
        return total + (current.nodeType === "heading-2" ? 1 : 0);
    }, 0);
    const isSidebar = totalHeading2 > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: title,
                description: metaDescription,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: title,
                        description: metaDescription,
                        url: currentPageURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: currentPageURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Robots */.ZP.Robots, {
                        content: metaRobotsContent
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                color: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* BreadcrumbItemLink */.A, {
                                    href: "/",
                                    children: "Home"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                    Component: Item/* BreadcrumbItemLink */.A,
                                    href: "/updates",
                                    children: "Updates"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuidePageTemplate/* default */.Z, {
                sidebar: isSidebar,
                children: [
                    navigation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar/* default */.Z, {
                        children: navigation.map((item)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* GuidePageTemplateNavItem */.hS, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* GuidePageTemplateNavItemLink */.NI, {
                                    href: "#".concat((0,utils/* generateHeadingId */.A)(item)),
                                    onClick: (e)=>(0,Guides/* scrollToHeading */.U)(e),
                                    children: item
                                })
                            }, item);
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main/* default */.Z, {
                        sidebar: isSidebar,
                        children: [
                            publishStatus === "Live" && wasReleasedMessage,
                            body ? (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(body, richTextTypes_default/* default */.Z) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToTopButton/* BackToTopButton */.z, {})
        ]
    });
};
ReleaseNotesPage.propTypes = {
    post: (0,prop_types.shape)({
        title: prop_types.string.isRequired,
        metaDescription: prop_types.string,
        appReleaseNotes: prop_types.object,
        appVersionNumber: prop_types.string,
        body: prop_types.object,
        publishStatus: (0,prop_types.oneOf)([
            "Hidden",
            constants/* PUBLISHED */.lc
        ]),
        releaseDate: prop_types.string,
        slug: prop_types.string,
        teaser: prop_types.object,
        macInstallerUrl: prop_types.string,
        windowsInstallerUrl: prop_types.string
    }),
    pageProps: (0,prop_types.shape)({
        resources: prop_types.any,
        siteDomain: prop_types.string
    })
};
/* harmony default export */ var Page = (ReleaseNotesPage);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/locales/index.js
var locales = __webpack_require__(5235);
var locales_default = /*#__PURE__*/__webpack_require__.n(locales);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/contentfulSanitizer.js
var contentfulSanitizer = __webpack_require__(50420);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/ReleaseNotes/index.js











const ContentfulReleaseNotesFactory = (param)=>{
    let { Layout , contentfulProps , pageProps  } = param;
    const ContentfulReleaseNotesPage = (param)=>{
        let { post  } = param;
        const { brandCode , resources =null  } = pageProps;
        const PageComponent = pageProps.PageComponent || Page;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18/* LocaleProvider */.Iw, {
                resources: resources || (locales_default())[brandCode],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageComponent, {
                    post: post,
                    pageProps: pageProps
                })
            })
        });
    };
    ContentfulReleaseNotesPage.getInitialProps = async (props)=>{
        const { slug  } = props.query;
        const client = (0,createClient/* default */.Z)(contentfulProps);
        const items = await client.getEntries({
            content_type: "pageReleaseNotes",
            "fields.slug": slug
        });
        if (items.total === 0) {
            return {
                post: null
            };
        }
        return {
            post: (0,contentfulSanitizer/* sanitize */.N)(items.items[0].fields)
        };
    };
    ContentfulReleaseNotesPage.propTypes = {
        ...Page.propTypes
    };
    ContentfulReleaseNotesPage.postConditions = [
        [
            (param)=>{
                let { post  } = param;
                return post;
            },
            (0,create_and_raise/* createAndRaise */.C)(ApplicationError/* default.NotFound */.Z.NotFound)
        ]
    ];
    return (0,pipe/* default */.Z)(ContentfulReleaseNotesPage, WithConditions/* default */.ZP);
};
/* harmony default export */ var ReleaseNotes = (ContentfulReleaseNotesFactory);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var _insightfulscience_i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(3918);
// EXTERNAL MODULE: ./src/SectionTryForFree/index.js
var SectionTryForFree = __webpack_require__(98106);
// EXTERNAL MODULE: ./src/AppError/index.js + 10 modules
var AppError = __webpack_require__(38209);
// EXTERNAL MODULE: ./locales/updates-page/index.js
var updates_page = __webpack_require__(27667);
var updates_page_default = /*#__PURE__*/__webpack_require__.n(updates_page);
;// CONCATENATED MODULE: ./pages/updates/[slug].js











const ReleaseNotesLayout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        image: "/images/snapgene/meta/preview-snapgene-dotmatics.png",
                        imageSecureUrl: "/images/snapgene/meta/preview-snapgene-dotmatics.png",
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        image: "/images/snapgene/meta/preview-snapgene-dotmatics.png",
                        isImageBaseUrl: true
                    })
                ]
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTryForFree/* default */.Z, {})
        ]
    });
};
ReleaseNotesLayout.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var _slug_ = ((0,pipe/* default */.Z)(ReleaseNotes({
    Layout: ReleaseNotesLayout,
    contentfulProps: {
        environment: "master",
        space: "d49zkrle08v9",
        accessToken: "892512d6e4c67cd995e1b1c2655b65f8c627ad3ff936c2ab3305fd173366b07f",
        proxy: null
    },
    pageProps: {
        brandCode: "sg",
        siteDomain: "https://www.snapgene.com"
    }
}), (0,_insightfulscience_i18/* WithLocale */._t)({
    resources: (updates_page_default())
}), AppError/* withErrorHandling */.b));


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 38209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ src_AppError; },
  "b": function() { return /* binding */ withErrorHandling; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ForceErrorHoC/index.js
var ForceErrorHoC = __webpack_require__(4354);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(76965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
;// CONCATENATED MODULE: ./src/AppError/Error400.js







const Error400 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("400");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("BAD_REQUEST")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/global-context/hook.js
var hook = __webpack_require__(63841);
;// CONCATENATED MODULE: ./src/utils/nav-hooks/useCurrentPath.js


/** @type {() => string} */ function useCurrentPath() {
    const context = (0,hook/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { asPath  } = router || context;
    return asPath;
}
/* harmony default export */ var nav_hooks_useCurrentPath = (useCurrentPath);

;// CONCATENATED MODULE: ./src/AppError/Error401.js








const Error401 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("401");
    const currentPath = nav_hooks_useCurrentPath();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_AUTHORIZED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: "".concat(routes/* default.logout */.ZP.logout, "?returnUrl=").concat(encodeURIComponent(currentPath)),
                        children: t("SIGN_IN")
                    }),
                    " ",
                    t("WITH_DIFFERENT_ACCOUNT"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js







const Error403 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("403");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_PERMITTED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error403 = (Error403);

;// CONCATENATED MODULE: ./src/AppError/Error404.js





const Error404 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("404");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_FOUND")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: t("DESC")
            })
        ]
    });
};
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js







const Error500 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("500");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("SOMETHING_WENT_WRONG")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error500 = (Error500);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js






const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "panel ".concat(color/* bgColorBlack */.ZH),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "".concat(color/* colorWhite */.A2, " px-5 py-5"),
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = (config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? ErrorDetails : ()=>null);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js + 1 modules
var Layout = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js + 3 modules
var SimpleTemplate = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js + 6 modules
var Header = __webpack_require__(38529);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./src/prerendered-logo.js
var prerendered_logo = __webpack_require__(25476);
;// CONCATENATED MODULE: ./src/AppError/ErrorLayout.js









/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Header */.Z.Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                    logo: prerendered_logo/* default */.ZP
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default.Body */.Z.Body, {
                className: color/* bgColorBlack2 */.vk,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTemplate/* default */.Z, {
                        children: children
                    }),
                    extra && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                        className: "pt-9 pt-9--md pb-18 pb-18--md",
                        children: extra
                    })
                ]
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types.node,
    extra: prop_types.node
};
/* harmony default export */ var AppError_ErrorLayout = (ErrorLayout);

// EXTERNAL MODULE: ./src/AppError/mapGraphQLErrors.js
var mapGraphQLErrors = __webpack_require__(20522);
// EXTERNAL MODULE: ./locales/errors-page/index.js
var errors_page = __webpack_require__(88054);
var errors_page_default = /*#__PURE__*/__webpack_require__.n(errors_page);
;// CONCATENATED MODULE: ./src/AppError/AppError.js














const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404
};
const AppError = (param)=>{
    let { error  } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorLayout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const appErr = (0,mapGraphQLErrors/* default */.ZP)(err);
    if (res) {
        res.statusCode = appErr.code;
    }
    if (appErr.code >= 500 && appErr.originalError != null) throw appErr.originalError;
    return {
        error: appErr.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_AppError = ((0,pipe/* default */.Z)(AppError, (0,i18/* WithLocale */._t)({
    resources: (errors_page_default())
})));

// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./src/graphql-local/unexpectedError/index.js + 3 modules
var unexpectedError = __webpack_require__(51041);
// EXTERNAL MODULE: ./src/sentry.js + 69 modules
var sentry = __webpack_require__(51720);
// EXTERNAL MODULE: ./src/utils/nav-hooks/useQueryString.js
var useQueryString = __webpack_require__(88046);
;// CONCATENATED MODULE: ./src/AppError/withErrorHandlingHoC.js










const withErrorHandlingHoC = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        const { data  } = (0,react_hooks_esm/* useQuery */.aM)(unexpectedError/* getUnexpectedError */.c);
        const asPath = nav_hooks_useCurrentPath();
        const query = (0,useQueryString/* default */.Z)();
        react.useEffect(()=>{
            if ((data === null || data === void 0 ? void 0 : data.unexpectedError) == null) return;
            (0,sentry/* notifySentry */.Yw)(ApplicationError/* default.of */.Z.of(data.unexpectedError), {
                asPath,
                query
            });
        }, [
            data === null || data === void 0 ? void 0 : data.unexpectedError
        ]);
        if (error == null && (data === null || data === void 0 ? void 0 : data.unexpectedError) == null) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_AppError, {
            error: error || ApplicationError/* default.of */.Z.of(data.unexpectedError)
        });
    };
    WithErrorHandling.propTypes = AppError_AppError.propTypes;
    WithErrorHandling.getInitialProps = (context)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context) : {};
            return (0,fn/* isPromise */.tI)(props) ? props.catch((err)=>AppError_AppError.getInitialProps({
                    ...context,
                    err
                })) : props;
        } catch (err) {
            return AppError_AppError.getInitialProps({
                ...context,
                err
            });
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ var AppError_withErrorHandlingHoC = (withErrorHandlingHoC);

;// CONCATENATED MODULE: ./src/AppError/index.js





const withErrorHandling = (0,fn/* compose */.qC)(AppError_withErrorHandlingHoC, config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? (0,ForceErrorHoC/* withForceError */.B)("throw") : fn/* idX */.Yr);
/* harmony default export */ var src_AppError = (AppError_AppError);


/***/ }),

/***/ 20522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I3": function() { return /* binding */ isNotFound; },
/* harmony export */   "_j": function() { return /* binding */ isNotAuthorized; }
/* harmony export */ });
/* unused harmony exports isGraphQLErrorIn, isBadRequest, isNotPermitted, isNetwork */
/* harmony import */ var _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66651);
/* eslint-disable no-nested-ternary, prettier/prettier */ 
const isGraphQLErrorIn = function() {
    for(var _len = arguments.length, codes = new Array(_len), _key = 0; _key < _len; _key++){
        codes[_key] = arguments[_key];
    }
    return (param)=>{
        let { graphQLErrors  } = param;
        return graphQLErrors && graphQLErrors.length && codes.includes(graphQLErrors[0].code);
    };
};
const isBadRequest = isGraphQLErrorIn(400, "INTERNAL_SERVER_ERROR");
const isNotAuthorized = isGraphQLErrorIn(401);
const isNotFound = isGraphQLErrorIn(400, 404);
const isNotPermitted = isGraphQLErrorIn(403);
const isNetwork = (param)=>{
    let { networkError  } = param;
    return networkError != null;
};
const mapGraphQLErrors = (error)=>isBadRequest(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 400) : isNotAuthorized(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 401) : isNotPermitted(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 403) : isNotFound(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 404) : isNetwork(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error) : _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"].of */ .Z.of(error);
/* harmony default export */ __webpack_exports__["ZP"] = (mapGraphQLErrors);


/***/ }),

/***/ 98106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19334);
/* harmony import */ var _insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73972);
/* harmony import */ var _insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18774);
/* harmony import */ var _insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46003);






const SectionTryForFree = ()=>{
    const [t] = (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__/* .useLocale */ .bU)("section-try-for-free");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Title */ .Z.Title, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    Tag: "span",
                    children: t("TRY_FREE_TEXT")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Action */ .Z.Action, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Link */ .Z.Link, {
                    href: "/free-trial",
                    size: "s",
                    className: "ml-auto mr-auto",
                    children: t("TRY_FREE_BUTTON_TEXT")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionTryForFree);


/***/ }),

/***/ 88046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89333);
/* harmony import */ var _global_context_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63841);




function useQueryString() {
    const context = (0,_global_context_hook__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { asPath  } = router || context;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(asPath), [
        asPath
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useQueryString);


/***/ }),

/***/ 71125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ BreadcrumbItemLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);



const BreadcrumbItemLink = (param)=>{
    let { href , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        href: href,
        className: "breadcrumbs__item-link",
        ...props,
        children: children
    });
};
BreadcrumbItemLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
const BreadcrumbItem = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "breadcrumbs__item",
        ...props
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadcrumbItem);


/***/ }),

/***/ 78086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Breadcrumbs_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/Breadcrumbs.js




const Breadcrumbs = (param)=>{
    let { className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("breadcrumbs", className),
        children: children
    });
};
Breadcrumbs.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/index.js



/***/ }),

/***/ 43360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const GuidePageTemplateMain = (param)=>{
    let { sidebar =true , children , ...props } = param;
    const responsiveProps = sidebar ? {
        auto: true
    } : {
        lg: 9
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        ...responsiveProps,
        ...props,
        children: children
    });
};
GuidePageTemplateMain.propTypes = {
    sidebar: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (GuidePageTemplateMain);


/***/ }),

/***/ 69738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NI": function() { return /* binding */ GuidePageTemplateNavItemLink; },
/* harmony export */   "hS": function() { return /* binding */ GuidePageTemplateNavItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);




const GuidePageTemplateNavItem = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "guide-page-template__nav-item",
        children: children
    });
};
GuidePageTemplateNavItem.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
const GuidePageTemplateNavItemLink = (param)=>{
    let { href , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        href: href,
        className: "guide-page-template__nav-item-link",
        ...props,
        children: children
    });
};
GuidePageTemplateNavItemLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
const GuidePageTemplateNav = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "guide-page-template__nav",
        children: children
    });
};
GuidePageTemplateNav.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["ZP"] = (GuidePageTemplateNav);


/***/ }),

/***/ 51921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const GuidePageTemplateSidebar = (param)=>{
    let { md =4 , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: md,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "guide-page-template__sidebar",
            children: children
        })
    });
};
GuidePageTemplateSidebar.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired,
    md: prop_types__WEBPACK_IMPORTED_MODULE_3__.number
};
/* harmony default export */ __webpack_exports__["Z"] = (GuidePageTemplateSidebar);


/***/ }),

/***/ 41635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GuidePageTemplate_GuidePageTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/GuidePageTemplate.js






const GuidePageTemplate = (param)=>{
    let { type ="guide" , wrapperClassName ="" , sidebar =true , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)("guide-page-template", "guide-page-template-type-".concat(type), wrapperClassName),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                center: !sidebar,
                children: children
            })
        })
    });
};
GuidePageTemplate.propTypes = {
    type: (0,prop_types.oneOf)([
        "guide",
        "tutorial"
    ]),
    wrapperClassName: prop_types.string,
    sidebar: prop_types.bool,
    children: prop_types.node.isRequired
};
/* harmony default export */ var GuidePageTemplate_GuidePageTemplate = (GuidePageTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/index.js



/***/ }),

/***/ 19334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionTryForFree_SectionTryForFree; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/SectionTryForFree.js





const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__title",
        children: children
    });
};
Title.propTypes = {
    children: prop_types.node.isRequired
};
const Action = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__action",
        children: children
    });
};
Action.propTypes = {
    children: prop_types.node.isRequired
};
const SectionTryForFree = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "section-try-for-free",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    utility: {
                        position: {
                            position: "relative",
                            zIndex: 1
                        }
                    },
                    children: children
                })
            })
        })
    });
};
SectionTryForFree.propTypes = {
    children: prop_types.node.isRequired
};
SectionTryForFree.Title = Title;
SectionTryForFree.Action = Action;
/* harmony default export */ var SectionTryForFree_SectionTryForFree = (SectionTryForFree);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/index.js



/***/ }),

/***/ 5370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ BackToTopButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18774);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61672);




const BackToTopButton = ()=>{
    const [showButton, setShowButton] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [prevOffset, setPrevOffset] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const toggleScrollDirection = ()=>{
        const { scrollY  } = window;
        const screenHeight = window.screen.height * 2;
        if (scrollY > prevOffset || scrollY < screenHeight) {
            setShowButton(false);
        } else if (scrollY < prevOffset && scrollY > screenHeight) {
            setShowButton(true);
        }
        setPrevOffset(scrollY);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        window.addEventListener("scroll", toggleScrollDirection);
        return ()=>{
            window.removeEventListener("scroll", toggleScrollDirection);
        };
    });
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "back-to-top-button",
            onClick: scrollToTop,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    name: "chevron-up",
                    className: "back-to-top-button--icon"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "back-to-top-button--text",
                    children: "TOP"
                })
            ]
        })
    });
};


/***/ }),

/***/ 61603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ scrollToHeading; }
/* harmony export */ });
const scrollToHeading = (e)=>{
    e.preventDefault();
    const siblingsFn = (elem)=>{
        const siblings = [];
        let sibling = elem;
        while(sibling.previousSibling){
            sibling = sibling.previousSibling;
            if (sibling.nodeType === 1) {
                siblings.push(sibling);
            }
        }
        sibling = elem;
        while(sibling.nextSibling){
            sibling = sibling.nextSibling;
            if (sibling.nodeType === 1) {
                siblings.push(sibling);
            }
        }
        return siblings;
    };
    const link = e.target;
    const activeClass = "guide-post-container__nav-item-link--active";
    link.classList.add(activeClass);
    siblingsFn(link.parentNode).forEach((sib)=>{
        if (!sib.getElementsByTagName("a").length) {
            return;
        }
        sib.getElementsByTagName("a")[0].classList.remove(activeClass);
    });
    const id = e.target.hash.replace("#", "");
    const element = document.getElementById(id);
    __webpack_require__.g.window.scrollTo({
        behavior: element ? "smooth" : "auto",
        top: element ? element.offsetTop : 0
    });
};


/***/ }),

/***/ 34491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ub": function() { return /* binding */ RELEASE_NOTES_PER_PAGE; },
/* harmony export */   "_E": function() { return /* binding */ GUIDE_TYPES; },
/* harmony export */   "aU": function() { return /* binding */ BRAND_NAMES; },
/* harmony export */   "ec": function() { return /* binding */ BRAND_CODE_SG; },
/* harmony export */   "gf": function() { return /* binding */ BRAND_CODE_LA; },
/* harmony export */   "h7": function() { return /* binding */ BRAND_CODE_OM; },
/* harmony export */   "lc": function() { return /* binding */ PUBLISHED; },
/* harmony export */   "yB": function() { return /* binding */ BRAND_CODE_GP; }
/* harmony export */ });
/* unused harmony exports BLOGS_PER_PAGE, BRAND_CODE_GN */
const RELEASE_NOTES_PER_PAGE = 20;
const BLOGS_PER_PAGE = 12;
const BRAND_CODE_GP = "gp";
const BRAND_CODE_SG = "sg";
const BRAND_CODE_GN = "gn";
const BRAND_CODE_OM = "om";
const BRAND_CODE_LA = "la";
const PUBLISHED = "Live";
const GUIDE_TYPES = {
    Guide: "guide",
    Tutorial: "tutorial"
};
const BRAND_NAMES = {
    om: "OMIQ",
    sg: "Snapgene",
    gp: "Graphpad",
    gn: "Geneious",
    la: "LabArchives"
};


/***/ }),

/***/ 33686:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TRY_FREE_TEXT":"Discover the most <b>user-friendly</b> molecular biology experience.","TRY_FREE_BUTTON_TEXT":"Try for Free"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,8610,7883,6468,2458,3918,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(35280); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);